<template>
  <div style="margin: 0">
    <div class="demo-alignment" >
      <vs-button
        @click="topluIslem()"
        color="#fc9551"
        gradient-color-secondary="rgb(255, 115, 0)"
        style="border-radius: 5px; height: 40px"
        type="gradient"
        >Toplu İşlem</vs-button
      >

      <vs-button
        @click="virmanEkle()"
        style="border-radius: 5px; height: 40px"
        color="success"
        type="gradient"
        >Hesap Virman</vs-button
      >
    </div>

    <vs-popup
      type="filled"
      pazaryer
      title="Toplu İşlem"
      :active.sync="popupTopluIslem"
    >
      <div>
        <div class="vx-row">
          <div class="vx-col lg:w-3/12" style="">
            <vs-button
              @click="topluIslemGonder()"
              id="toplu-islem-loading"
              class="vs-con-loading__container"
              style="height: 40px; margin-bottom: 15px"
              color="primary"
              icon="done"
              type="filled"
              >Gönder</vs-button
            >
          </div>
          <div class="vx-col lg:w-3/12" style=""></div>
          <div class="vx-col lg:w-4/12" style=""></div>
          <vs-progress
            :percent="progress"
            v-model="progress"
            color="primary"
          ></vs-progress>
        </div>

        <vs-divider />

        <vs-table :data="topluislemlist">
          <template slot="thead">
            <vs-th sort-key="CARIADI">Cari Ad</vs-th>

            <vs-th sort-key="CARI_KOD">Cari Kod</vs-th>
            <vs-th sort-key="BACIKLAMA">Açıklama</vs-th>
            <vs-th sort-key="EACIK9">Program</vs-th>
            <vs-th sort-key="GIB_FATIRS_NO">Gib Fatura No</vs-th>
            <vs-th sort-key="GENELTOPLAM">Genel Toplam</vs-th>
            <vs-th sort-key="TARIH">Tarih</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].CARIADI">
                {{ data[indextr].CARIADI }}<br />
              </vs-td>
              <vs-td :data="data[indextr].CARI_KOD">
                {{ data[indextr].CARI_KOD }}<br />
              </vs-td>

              <vs-td :data="data[indextr].BACIKLAMA">
                {{ data[indextr].BACIKLAMA }}<br />
              </vs-td>
              <vs-td :data="data[indextr].EACIK9">
                {{ data[indextr].EACIK9 }}<br />
              </vs-td>
              <vs-td :data="data[indextr].GIB_FATIRS_NO">
                {{ data[indextr].GIB_FATIRS_NO }}<br />
              </vs-td>
              <vs-td :data="data[indextr].GENELTOPLAM">
                {{ data[indextr].GENELTOPLAM }}<br />
              </vs-td>
              <vs-td :data="data[indextr].TARIH">
                {{ data[indextr].TARIH }}<br />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import state from "../../../../store/state";
import Store from "../../../../store/store";
import vSelect from "vue-select";
export default {
  props: ["program", "secilenFatura", "denemeMet"],
  components: {
    vSelect,
  },
  data() {
    return {
      progress: 0,
      islemDurumu: false,
      oran: 0,
      topluislemlist: [],
      popupTopluIslem: false,
      colorLoading: "#fff",
    };
  },
  methods: {
    virmanEkle() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.faturavirman(args, function (err, result) {
          console.log(result);
          if (result.faturavirmanResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          if (result.faturavirmanResult == "") {
            vs.notify({
              text: "Virman işlemi tamamlandı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          }
        });
      });
    },
    faturaListeleme() {
      this.$root.$emit("faturaAktarimList");
    },
    topluIslemGonder() {
      var vm = this;
      var vs = this.$vs;
      var faturalist = vm.secilenFatura;

      var faturaNolar = [];
      var faturaNolarString = "";

      faturalist.forEach((val, index) => {
        faturaNolar.push({
          cari_kod: faturalist[index].CARI_KOD,
          fatirs_no: faturalist[index].FATIRS_NO,
          tarih: faturalist[index].TARIH,
          tipi: faturalist[index].TIPI,
          muh_carikod: faturalist[index].MUH_CARIKOD,
          brut_tutar: faturalist[index].BRUTTUTAR,
          sat_iskt: faturalist[index].SAT_ISKT,
          kdv: faturalist[index].KDV,
          b_aciklama: faturalist[index].BACIKLAMA,
          odeme_tarihi: faturalist[index].ODEMETARIHI,
          kdv_dahilmi: faturalist[index].KDV_DAHILMI,
          fat_kalem_adeti: faturalist[index].FATKALEM_ADEDI,
          genel_toplam: faturalist[index].GENELTOPLAM,
          pla_kodu: faturalist[index].PLA_KODU,
          ks_kodu: faturalist[index].KS_KODU,
          onay_tipi: faturalist[index].ONAYTIPI,
          isletme_kodu: faturalist[index].ISLETME_KODU,
          gib_fatirs_no: faturalist[index].GIB_FATIRS_NO,
          sube: faturalist[index].SUBE,
          eacik1: faturalist[index].EACIK1,
          eacik2: faturalist[index].EACIK2,
          eacik5: faturalist[index].EACIK5,
          eacik8: faturalist[index].EACIK8,
          eacik9: faturalist[index].EACIK9,
        });
      });

      var jsonConvertfatura = JSON.stringify(faturaNolar);

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: vm.program,
        faturas: jsonConvertfatura,
      };

      vs.loading({
        background: "#0064fa",
        color: vm.colorLoading,
        container: "#toplu-islem-loading",
        scale: 0.45,
      });
      if (faturaNolar == []) {
        vs.notify({
          text: "Fatura seçmediniz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "red",
          position: "top-center",
        });
      } else {
        soap.createClient(url, function (err, client) {
          client.faturaAktar(args, function (err, result) {
            if (result.faturaAktarResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              console.log(result);
              vm.veriler = JSON.parse(result.faturaAktarResult);
              if (vm.veriler.response == "Ok") {
                vs.loading.close("#toplu-islem-loading > .con-vs-loading");

                vs.notify({
                  text: "Fatura gönderim başarılı",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });

                vm.popupTopluIslem = false;
              } else {
                vs.loading.close("#toplu-islem-loading > .con-vs-loading");
                vs.notify({
                  text: vm.veriler.errorMessage,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
                if (vm.veriler.message.aktarilmayan != "0") {
                  vs.notify({
                    text:
                      "Aktarılamayan Fatura: " +
                      vm.veriler.message.aktarilmayanDetay,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              }
            } catch (error) {
              vs.loading.close("#toplu-islem-loading > .con-vs-loading");
              console.log(result);
              console.log(error);
              vm.popupTopluIslem = false;
              vs.notify({
                text: "Fatura gönderimi başarısız",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          });
        });
        vm.faturaListeleme();
      }
    },

    pazaryeriList(text) {
      //  console.log(text);
    },
    topluIslem() {
      this.popupTopluIslem = true;
      //  console.log(Store.state.uzum.secilenNetsisFaturaAktarim);
      // this.topluislemlist = Store.state.uzum.secilenNetsisFaturaAktarim;
      this.topluislemlist = this.secilenFatura;
      //  this.progress = 0;
    },
  },
};
</script>